// 树形展开和展开行
export default function useExpandRow(Table) {
    return Table;
}

useExpandRow.displayName = 'useExpandRow';
useExpandRow.dependence = [];
useExpandRow.hooks = function() {
    this.store.expandedRowKeys = new Set();
    return {
        getExpandedRowKeys: () => {
            return this.store.expandedRowKeys;
        },
        setExpandedRowKeys: expandedRowKeys => {
            this.store.expandedRowKeys = expandedRowKeys;

            this.forceUpdate();
        },
    };
};
useExpandRow.propsGenerator = function(props) {
    if (props.treeConfig?.enable) {
        return props;
    }

    let { expandConfig, store } = props;

    expandConfig = { 
        ...expandConfig,
        expandedKeys: store.getExpandedRowKeys(),
        onExpand: (rowKey, { isExpanded, expandedKeys }) => {
            store.setExpandedRowKeys(expandedKeys);
            props.expandConfig?.onExpand?.(rowKey, { isExpanded, expandedKeys });
        },
    };

    return {
        ...props,
        expandConfig,
    };
};